<template>
  <div class="h-100">
    <div class="position-relative">
      <div class="page-title-wrapper">
        <div
          class="page-title"
          @click="$router.push(`/payee/${payeeId}/payers`)"
        >
          {{ $t('menu.payers') }}
        </div>
        <div
          v-if="payeeAdmin"
          class="page-title active ml-4"
          @click="$router.push(`/payee/${payeeId}/payers/vindication`)"
        >
          {{ $t('menu.vindication') }}
        </div>
      </div>
    </div>

    <div>
      <div
        v-if="!prepare"
        class="d-flex align-items-center"
      >
        <PayerPropertyTypeDropdown
          :sort-key.sync="sortKey"
          class="mr-3"
        />

        <PayersGroupFilterDropdown
          :selected.sync="groupFilter"
          class="mr-3"
          @edit="groupEdit = true"
        />
        <SearchBox
          v-model="search"
          lazy
          class="mr-3"
        />
        <PayersPageSettingModal
          v-if="payee && payeeAdmin"
          layout-key="PAYERS_VINDICATION_LAYOUT"
          :with-categories="false"
          :with-future-balance="false"
          @layout="initLayout"
        />
      </div>
      <hr
        v-if="!prepare"
        class="mt-2 mb-0"
      >

      <div
        v-if="!prepare"
        class="sticky-top bg-white"
      >
        <div class="row py-2 align-items-center justify-content-between">
          <div class="col-12 col-md-4">
            <div>
              <div
                class="d-flex align-items-center"
                style="height: 40px"
              >
                <Checkbox
                  :value="groupCheck['#all']"
                  @update:value="toggleAll($event)"
                />
                <div
                  v-if="Object.keys(selected).length > 0"
                  class="d-flex align-items-center"
                >
                  <div class="pl-2 small text-primary text-nowrap">
                    {{ $t('form.selected') }}: {{ Object.keys(selected).length }}
                  </div>

                  <div>
                    <button
                      class="btn btn-sm btn-primary ml-3"
                      @click="prepare = true"
                    >
                      {{ $t('vindication.prepare') }}
                    </button>
                  </div>
                </div>
                <div
                  v-else
                  class="pl-3 d-flex"
                />
              </div>
            </div>
          </div>
          <div class="d-flex col-12 col-md-auto">
            <CategoryMultiselectDropdown
              :selected.sync="categoryIds"
              :hide-refunds="true"
              class="mr-3"
            />
            <div class="days-input-container">
              <div class="filter-header">
                Dni po terminie
              </div>
              <input
                v-model="daysDelay"
                :placeholder="$t('general.search')"
                class="form-control form-control-sm search-input"
              >
            </div>
          </div>
        </div>
        <hr class="mb-1 mt-0">
      </div>
      <div
        v-if="!prepare"
        class="d-flex"
      >
        <div
          style="overflow-x: auto"
          :style="{
            'flex-shrink': 0,
            'flex-basis': listWidth,
          }"
        >
          <div
            v-if="!!payee && payersLayout"
            class="pb-5"
            style="min-width: min-content; width: 100%; height: calc(100vh - 250px)"
          >
            <PayerHeaderRow
              :hide-details="!!edited"
              :layout="layoutWithCategories"
              :balance-columns="balanceColumns"
            />

            <div
              class="position-relative page-content w-100"
            >
              <div
                v-for="payer in filteredPayers"
                :key="payer.id"
                data-test="client-list-element"
                class="client-row w-100"
              >
                <PayerRow
                  class="list-complete-item"
                  v-bind="payer"
                  :hide-details="!!edited"
                  :edited="edited && payer.id == edited.id"
                  :checked="!!selected[payer.id]"
                  :layout="layoutWithCategories"
                  @select="toggleEdit(payer)"
                  @toggle="toggleClient(payer, $event)"
                />
              </div>
              <div
                v-if="!busy && filteredPayers.length === 0"
                class="small py-2 pl-2 text-secondary"
              >
                {{ $t('company.noPayers') }}
              </div>
              <div
                v-if="error"
                class="text-danger text-center pt-4 small"
              >
                {{ $t('error.fail') }}
              </div>
              <div v-else-if="busy">
                <Loader />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="edited"
          class="pt-2 width-transition"
          :style="{
            'flex-basis': edited ? '50%' : 0,
          }"
        >
          <div
            class="sticky-top pt-4 px-4 page-content w-100"
            style="max-height: 100vh; overflow: auto; top: 50px; min-height: 100px"
          >
            <CloseButton
              style="position: absolute; right: 8px; top: 12px; z-index: 100"
              @click.native.stop="toggleEdit(edited)"
            />
            <Transition
              name="client-details"
              mode="out-in"
            >
              <PayerVindication
                :payer="filteredPayers.find((x) => x.id === edited.id)"
              />
            </Transition>
          </div>
        </div>
      </div>

      <div v-if="prepare">
        <MessagePrepare
          :payers="selected"
          :sort-key="sortKey"
          :category-ids="categoryIds"
          :days-delay="daysDelay"
          :group="groupFilter"
          @close="prepare = false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import PayerHeaderRow from '@/components/payers/PayerHeaderRow';
import PayerRow from '@/components/payers/PayerRow';
import PayersGroupFilterDropdown from '@/components/payers/PayersGroupFilterDropdown';
import PayersPageSettingModal from '@/components/payers/PayersPageSettingModal';
import Checkbox from '@/components/utils/Checkbox';
import { mapActions, mapGetters } from 'vuex';
import CategoryMultiselectDropdown from '@/components/reports/CategoryMultiselectDropdown';
import PayerPropertyTypeDropdown from '@/components/payers/PayerPropertyTypeDropdown';
import PayerVindication from '@/components/payers/PayerVindication';
import MessagePrepare from '@/components/payers/vindication/MessagePrepare';
import moment from 'moment';

export default {
  data: () => ({
    newClient: null,
    groupAssignement: false,
    pendingRemove: false,
    groupEdit: false,
    edited: null,
    search: '',
    categoryIds: [],
    addingClient: false,
    detailsReady: false,
    sortKey: 'email',
    busy: false,
    groupFilter: '#all',
    payers: [],
    collapsed: {},
    selected: {},
    haveLayout: false,
    groupPending: {},
    groupCheck: {},
    bottom: false,
    error: null,
    requestId: 0,
    groupRefresh: 0,
    daysDelay: 0,
    payersLayout: null,
    outstandingBills: {},
    pendingOutstandingBills: false,
    prepare: false,
  }),
  components: {
    Checkbox,
    PayerRow,
    PayerHeaderRow,
    MessagePrepare,
    PayerVindication,
    PayersGroupFilterDropdown,
    PayersPageSettingModal,
    PayerPropertyTypeDropdown,
    CategoryMultiselectDropdown,
  },
  computed: {
    ...mapGetters([
      'payeeId',
      'tenantId',
      'selectedPayers',
      'payeeProperty',
      'payee',
      'payeeAdmin',
      'anyCategoryAccess',
      'properties',
    ]),
    vindication() {
      return !!this.$route.query.vindication;
    },
    listWidth() {
      if (this.edited) {
        return '50%';
      }
      return '100%';
    },
    rawLayout() {
      return this.payeeProperty('PAYERS_VINDICATION_LAYOUT');
    },
    all: {
      get() {
        if (!this.selected || !this.payers) return null;
        if (this.payers.length === 0) return false;
        return this.selected.length === this.filteredPayers.length;
      },
      set(v) {
        if (!v) {
          this.selected = {};
        } else {
          this.selected = this.filteredPayers.slice();
        }
      },
    },
    balanceColumns() {
      const categories = this.payee?.categories || [];

      return this.categoryIds.map((x) => ({
        categoryId: x,
        currency: 'PLN',
        category: categories.find((y) => y.id === x),
      }));
    },
    filteredPayers() {
      if (this.sortKey === 'email') {
        const payerByEmail = this.payers
          .reduce((acc, curr) => {
            this.emailProperties
              .map((pid) => curr.properties[pid])
              .filter((x) => x && x.includes('@'))
              .forEach((email) => {
                if (!email) return;

                if (acc[email]) {
                  acc[email].push(curr);
                } else {
                  acc[email] = [curr];
                }
              });

            return acc;
          }, {});

        return Object.entries(payerByEmail)
          .map(([email, payers]) => ({
            id: email,
            name: email,
            code: '',
            groups: payers.length
              ? payers.reduce((acc, curr) =>
                acc.filter((g) => curr.groups.includes(g)),
              payers[0]?.groups || [])
              : [],
            properties: payers.length
              ? Object.keys(payers[0]?.properties || {}).reduce((acc, propKey) => {
                const allHaveProp = payers.every((p) => p.properties[propKey] === payers[0].properties[propKey]);
                if (allHaveProp) {
                  acc[propKey] = payers[0].properties[propKey];
                } else if (payers.some((p) => p.properties[propKey])) {
                  acc[propKey] = '[różne]';
                }
                return acc;
              }, {})
              : {},
            type: 'Person',
            payerIds: payers.map((x) => x.id),
          }))
          .map((x) => this.fillBalanceColumns(x, x.payerIds))
          .filter((x) => x.balance.some((y) => y.balance < 0));
      }

      if (this.sortKey === 'phone') {
        const payerByPhone = this.payers
          .reduce((acc, curr) => {
            this.phoneProperties
              .map((pid) => curr.properties[pid])
              .filter((x) => x && (x.replace(/\D/g, '').length >= 9))
              .forEach((phone) => {
                if (!phone) return;

                if (acc[phone]) {
                  acc[phone].push(curr);
                } else {
                  acc[phone] = [curr];
                }
              });

            return acc;
          }, {});

        return Object.entries(payerByPhone)
          .map(([email, payers]) => ({
            id: email,
            name: email,
            code: '',
            groups: payers.length
              ? payers.reduce((acc, curr) =>
                acc.filter((g) => curr.groups.includes(g)),
              payers[0]?.groups || [])
              : [],
            properties: payers.length
              ? Object.keys(payers[0]?.properties || {}).reduce((acc, propKey) => {
                const allHaveProp = payers.every((p) => p.properties[propKey] === payers[0].properties[propKey]);
                if (allHaveProp) {
                  acc[propKey] = payers[0].properties[propKey];
                } else if (payers.some((p) => p.properties[propKey])) {
                  acc[propKey] = '[many]';
                }

                return acc;
              }, {})
              : {},
            type: 'Person',
            payerIds: payers.map((x) => x.id),
          }))
          .map((x) => this.fillBalanceColumns(x, x.payerIds))
          .filter((x) => x.balance.some((y) => y.balance < 0));
      }

      return this.payers
        .map((x) => ({ ...x, payerIds: [x.id] }))
        .map((x) => this.fillBalanceColumns(x, x.payerIds))
        .filter((x) => x.balance.some((y) => y.balance < 0));
    },
    emailProperties() {
      return this.properties.filter((x) => x.type === 'Email').map((x) => x.code);
    },
    phoneProperties() {
      return this.properties.filter((x) => x.type === 'Phone').map((x) => x.code);
    },
    layoutWithCategories() {
      return this.payersLayout
        .concat(this.categoryIds.map((x) => ({
          key: x,
          type: 'category',
        })));
    },
  },
  watch: {
    collapsed: {
      deep: true,
      handler() {
        this.refresh();
      },
    },
    sortKey() {
      this.collapsed = {};
      this.selected = {};
      this.refresh();
    },
    search() {
      this.refresh();
    },
    groupFilter() {
      this.refresh();
    },
  },
  methods: {
    ...mapActions([
      'getOutstandingBills',
      'getPayers',
      'getPayeeProperties',
      'archivePayers',
      'exportPayers',
    ]),
    pullOutstandingBills() {
      this.pendingOutstandingBills = true;
      this.getOutstandingBills({
        params: {
          query: {
            allPayers: true,
          },
        },
      })
        .then(({ data }) => {
          const payerIds = Array.from(new Set(data.map((x) => x.payerId)));

          payerIds.forEach((id) => {
            this.$set(this.outstandingBills, id, data.filter((x) => x.payerId === id));
          });
        })
        .finally(() => {
          this.pendingOutstandingBills = false;
        });
    },
    initLayout({ layout }) {
      this.haveLayout = true;
      this.payersLayout = layout;
      this.refresh();
    },
    showAddMessage() {
      this.$router.push(`/payee/${this.payeeId}/messages/messages?useSelectedPayers=1`);
    },
    showAddBill() {
      this.$router.push(`/payee/${this.payeeId}/bills/form?useSelectedPayers=1`);
    },
    fillBalanceColumns(row, payerIds) {
      const payersBills = payerIds
        .flatMap((id) => this.outstandingBills[id] || [])
        .filter((x) => this.categoryIds.includes(x.categoryId))
        .filter((x) => moment().subtract(this.daysDelay, 'days').isAfter(x.dueDate));

      return {
        ...row,
        bills: payersBills,
        balance: this.balanceColumns
          .map((y) => ({
            balance: -(payersBills
              .filter((x) => x.categoryId === y.categoryId)
              .reduce((acc, curr) => acc + (curr.amount - curr.paid), 0)),
            categoryId: y.categoryId,
            currency: y.currency,
          })),
      };
    },
    refresh() {
      this.skip = 0;
      this.busy = false;
      this.payers = [];
      this.requestId += 1;
      this.request();
    },
    request() {
      if (!this.haveLayout) return;

      this.error = null;
      const id = this.requestId;
      this.busy = true;

      let withProperty = this.payersLayout
        .filter((x) => x.type === 'property')
        .map((x) => x.key);

      if (this.sortKey === 'email') {
        withProperty = [...withProperty, ...this.emailProperties];
      } else if (this.sortKey === 'phone') {
        withProperty = [...withProperty, ...this.phoneProperties];
      }

      this.pullOutstandingBills();

      this.getPayers({
        params: {
          query: {
            withBills: false,
            withActivation: false,
            skip: 0,
            take: -1,
            sort: 'name',
            withGroup: this.payersLayout.filter((x) => x.type === 'group').map((x) => x.key),
            withProperty,
            group: this.groupFilter === '#all'
              ? undefined
              : this.groupFilter,
            search: this.search.length === 0
              ? undefined
              : this.search,
          },
        },
      })
        .then(({ data }) => {
          if (id !== this.requestId) {
            return;
          }
          this.skip += this.take;
          this.payers = data;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.busy = false;
        });
    },
    toggleAll(v) {
      if (!v) {
        this.selected = {};
        this.$set(this.groupCheck, '#all', v);
        return;
      }

      this.$set(this.groupCheck, '#all', v);
      if (v) {
        this.filteredPayers.forEach((x) => {
          this.$set(this.selected, x.id, x);
        });
      } else {
        this.filteredPayers.forEach((x) => {
          this.$delete(this.selected, x.id);
        });
      }
    },
    toggleEdit(payer) {
      clearTimeout(this.timeout);
      if (this.edited == null || this.edited.id !== payer.id) {
        this.edited = payer;
        this.timeout = setTimeout(() => {
          this.detailsReady = true;
        }, 200);
      } else {
        this.edited = null;
        this.detailsReady = false;
      }
    },
    toggleClient(c, isSelected) {
      const ids = Object.keys(this.selected);
      const saved = ids.includes(c.id);
      if (isSelected && !saved) {
        this.$set(this.selected, c.id, c);
      } else if (!isSelected && saved) {
        this.$delete(this.selected, c.id);
      }
    },
    showArchived() {
      this.$router.push(`/payee/${this.payeeId}/payers/archived`);
    },
  },
  created() {
    this.$emit('page', 'payers');

    this.selectedPayers.forEach((p) => {
      this.$set(this.selected, p.id, p);
    });

    this.getPayeeProperties({
      params: {
        query: {
          names: 'PAYERS_VINDICATION_LAYOUT',
        },
      },
    });

    this.request();
  },
  mounted() {
    this.onKeyDown = (ev) => {
      if (!this.edited) { return; }

      const { key } = ev;

      // jump to next client
      if (key === 'ArrowDown') {
        const ci = this.filteredPayers.findIndex((y) => y.id === this.edited.id);
        if (ci < this.filteredPayers.length) {
          this.edited = this.filteredPayers[ci + 1];
        }
      } else if (key === 'ArrowUp') {
        const ci = this.filteredPayers.findIndex((y) => y.id === this.edited.id);
        if (ci > 1) {
          this.edited = this.filteredPayers[ci - 1];
        }
      }
    };

    if (this.$route.query.payerId) {
      this.toggleEdit({ id: this.$route.query.payerId });
    }

    if (this.payee) {
      this.categoryIds = this.payee.categories.map((x) => x.id);
    }

    document.addEventListener('keydown', this.onKeyDown);
  },
  destroyed() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
};
</script>

<style lang="scss" scoped>

  @import '~@/components/reports/small-filter.scss';

  .info-row {
    border-bottom: 1px solid #dddddd;
    font-size: 12px;
    font-weight: 400;
    padding-top: 3px;
    padding-bottom: 7px;
    width: min-content;
  }

  .days-input-container {
    width: 110px;

    .search-input {
      font-size: 14px;
    }
  }

  .page-content {
    height: calc(100vh - 285px);
    overflow-y: scroll;
    padding-bottom: 50px;
    scrollbar-width: 20px;
    width: min-content;
  }

  .group-title {
    font-weight: 500;
    padding-top: 10px;
  }

  .light-button {
    position: absolute;
    top: 20px;
    right: -10px;
  }

  .grouping-prop {
    font-weight: bold;
    cursor: pointer;
    padding: 5px 10px;
    &:hover {
      background-color: rgba(100, 100, 100, 0.2);
    }
  }

  .payment-info-title {
    max-width: 250px;
    padding-left: 10px;
  }

  .xs-add {
    top: 2px;
    right: 4px;
  }

  .slide-enter,
  .slide-leave-to { opacity: 0; max-height: 0px; }

  .slide-leave,
  .slide-enter-to { opacity: 1; max-height: 500px; }

  .slide-enter-active { transition: opacity 400ms, max-height 400ms }
  .slide-leave-active { transition: opacity 200ms, max-height 200ms }

  @media screen and (max-width: 765px) {
    .payment-info-title {
      max-width: 120px;
    }
  }

  .client-details-enter-active,
  .client-details-leave-active {
    transition: opacity 200ms, transform 200ms;
  }

  .client-details-enter, .client-details-leave-to {
    opacity: 0;
    transform: translateX(-10px);
  }

</style>
